import moment from 'moment'

class Date {
    static format = (date, format = 'DD/MM/YYYY') => {
        return (moment(date).format(format))
    }
}

export default Date
